import { Route } from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { hasScopesGuard } from '../../shared/guards/has-scopes.guard';
import { hasScopesResolver } from '../../shared/resolvers/has-scopes.resolver';
import { driverResolver } from './driver.resolver';

export const driverRoutes: Route[] = [
  {
    path: '',
    title: _('i18n.Driver.List.Title'),
    loadComponent: () =>
      import('./driver-list/driver-list.component').then(
        (m) => m.DriverListComponent,
      ),
    resolve: { hasWriteScope: hasScopesResolver(['drivers:write']) },
  },
  {
    path: ':driverId',
    children: [
      {
        path: 'detail',
        resolve: {
          driver: driverResolver,
          hasWriteScope: hasScopesResolver(['drivers:write']),
        },
        loadComponent: () =>
          import('./driver-detail/driver-detail.component').then(
            (m) => m.DriverDetailComponent,
          ),
      },
      {
        path: 'edit',
        resolve: { driver: driverResolver },
        loadComponent: () =>
          import('./driver-edit/driver-edit.component').then(
            (m) => m.DriverEditComponent,
          ),
        canActivate: [hasScopesGuard(['drivers:write'])],
      },
    ],
  },
];
